import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserAuthContext } from '../context/AuthContext';
import TransparentLogo from '../images/TransparentLogo.png';
import MenuHead from './MenuHead';
import MessagesError from './MessagesError';
import { useTranslation } from 'react-i18next';
import MeritsInput from '../shared/MeritsInput';
import { Button } from '@material-tailwind/react';

const Signin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { signIn } = UserAuthContext();
  const navigate = useNavigate();

  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await signIn(email, password);
      if (
        email === 'taxreturn@meritsaccounting.ca' ||
        email === 'pedro.bfinkler@gmail.com' ||
        email === 'alexsalesramos@gmail.com' ||
        email === 'victorvhrs@outlook.com' ||
        email === 'ale.osantos.oficial@gmail.com'
      ) {
        navigate('/admin');
      } else {
        navigate('/account');
      }
    } catch (e) {
      setError(e.code);
      console.log(e.code.slice(5).replace(/-/g, ' '));
    }
  };

  const { user } = UserAuthContext();

  if (user) {
    return (
      <div className="w-full p-6 mx-auto rounded-md shadow-sm sm:max-w-xl bg-blue-50 mt-40">
        <img src={TransparentLogo} alt="Logo" className="mx-auto h-28" />
        <Link className="underline ml-8" to="/account">
          {t('signIn.continueToAccount')}
        </Link>
      </div>
    );
  }

  return (
    <>
      <MenuHead />
      <div className="flex flex-col justify-center m-4">
        {error && <MessagesError error={error} setError={setError} />}
        <div className="w-full px-6 mx-auto rounded-md shadow-md lg:max-w-xl bg-gradient-to-tl from-blue-200">
          <Link to="/">
            <img src={TransparentLogo} alt="Logo" className="mx-auto" />
          </Link>
          <p className="mt-0 text-xs font-light text-left text-gray-70">
            {t('signIn.noAccount')}{' '}
            <Link className="underline" to="/signup">
              {t('signIn.signUp')}
            </Link>
          </p>
          <p className="mt-1 text-xs font-light text-left text-gray-70">
            {t('signIn.forgotPassword')}{' '}
            <Link className="underline" to="/recoverPass">
              {t('clickHere')}
            </Link>
          </p>
          <h3 className="text-2xl font-semibold text-center text-blue-900  pt-8 ">
            {t('signIn.title')}
          </h3>
          <form onSubmit={handleSubmit} className="flex flex-col mt-6 gap-4">
            <MeritsInput
              label={t('email')}
              required={true}
              type="email"
              placeholder={t('password')}
              value={email}
              onChange={({ target }) => setEmail(target.value)}
            />
            <MeritsInput
              label={t('password')}
              required={true}
              type="password"
              placeholder={t('password')}
              value={password}
              onChange={({ target }) => setPassword(target.value)}
            />
            <Button
              disabled={!email || !password}
              className="w-full transform bg-blue-900 rounded-md hover:bg-blue-600focus:bg-blue-600 mb-4"
              onClick={handleSubmit}
            >
              {t('signIn.signIn')}
            </Button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Signin;
